// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"8dbecd65","103":"690b4850","140":"80236af8","218":"938d78a4","263":"684a775a","473":"c8f4f57f","481":"aa9c26e1","591":"165a141f","705":"efe00084","761":"e7e83a82","825":"c2858a14","967":"f898fe3c"}[chunkId] + ".chunk.js";
};